webpackJsonp([213720915766396],{

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/audit_c.015816f9.png";

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cashtracker_a.63b376bf.png";

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/expense_c.843e3407.png";

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot2.0a069cea.jpg";

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/npe_c.58536dfc.png";

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _npe_c = __webpack_require__(441);
	
	var _npe_c2 = _interopRequireDefault(_npe_c);
	
	var _audit_c = __webpack_require__(438);
	
	var _audit_c2 = _interopRequireDefault(_audit_c);
	
	var _expense_c = __webpack_require__(440);
	
	var _expense_c2 = _interopRequireDefault(_expense_c);
	
	var _headshot = __webpack_require__(52);
	
	var _headshot2 = _interopRequireDefault(_headshot);
	
	var _cashtracker_a = __webpack_require__(439);
	
	var _cashtracker_a2 = _interopRequireDefault(_cashtracker_a);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Projects = function Projects(props) {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      { className: "center-text" },
	      _react2.default.createElement("img", { className: "headshot", src: _headshot2.default, alt: "Headshot" })
	    ),
	    _react2.default.createElement(
	      "h1",
	      { className: "h1-index" },
	      "Projects"
	    ),
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Cash Tracker"
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "a",
	        { href: "https://cashtracker.netlify.com" },
	        _react2.default.createElement("img", { className: "project-image", src: _cashtracker_a2.default })
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "A React app to record personal expenses. A React Native",
	      " ",
	      _react2.default.createElement(
	        "a",
	        {
	          className: "inline-link",
	          href: "https://github.com/andrewjford/oozetracker2_native"
	        },
	        "client"
	      ),
	      " ",
	      "that uses the same back-end is also in development."
	    ),
	    _react2.default.createElement(
	      "a",
	      {
	        className: "trad-link",
	        href: "https://github.com/andrewjford/oozetracker2_react"
	      },
	      "GitHub"
	    ),
	    _react2.default.createElement(
	      "a",
	      { className: "trad-link", href: "https://cashtracker.netlify.com" },
	      "Demo"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Some of the tools used:"
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        "React"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Redux"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Express API"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "PostgreSQL"
	      )
	    ),
	    _react2.default.createElement(
	      "h2",
	      null,
	      "National Park Explorer"
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "a",
	        { href: "http://natl-park-explorer.netlify.com" },
	        _react2.default.createElement("img", { className: "project-image", src: _npe_c2.default })
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "A map based web app that allows users to explore U.S. National Parks."
	    ),
	    _react2.default.createElement(
	      "a",
	      {
	        className: "trad-link",
	        href: "https://github.com/andrewjford/national-park-explorer-react"
	      },
	      "GitHub"
	    ),
	    _react2.default.createElement(
	      "a",
	      { className: "trad-link", href: "http://natl-park-explorer.netlify.com" },
	      "Demo"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Some of the tools used:"
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        "React"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Redux"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Ruby on Rails API"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "U.S. National Park Service Data API"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Leaflet open-source JavaScript library"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "PostgreSQL"
	      )
	    ),
	    _react2.default.createElement(
	      "h2",
	      null,
	      "AuditRequest"
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "a",
	        { href: "http://auditrequest.herokuapp.com" },
	        _react2.default.createElement("img", { className: "project-image", src: _audit_c2.default, width: "100%" })
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "A project management and communications tool for audit firms and their clientele."
	    ),
	    _react2.default.createElement(
	      "a",
	      {
	        className: "trad-link",
	        href: "https://github.com/andrewjford/audit-request-manager"
	      },
	      "GitHub"
	    ),
	    _react2.default.createElement(
	      "a",
	      { className: "trad-link", href: "http://auditrequest.herokuapp.com" },
	      "Demo"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Some of the tools used:"
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        "Ruby on Rails"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "jQuery"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Handlebars"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Devise"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Pundit"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "OmniAuth"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "PostgreSQL"
	      )
	    ),
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Expense Tracker"
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "a",
	        { href: "http://oozetracker.herokuapp.com" },
	        _react2.default.createElement("img", { className: "project-image", src: _expense_c2.default, width: "100%" })
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "A web app to record personal expenses by category and track spending habits."
	    ),
	    _react2.default.createElement(
	      "a",
	      {
	        className: "trad-link",
	        href: "https://github.com/andrewjford/expense-tracker"
	      },
	      "GitHub"
	    ),
	    _react2.default.createElement(
	      "a",
	      { className: "trad-link", href: "https://oozetracker.herokuapp.com/" },
	      "Demo"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Some of the tools used:"
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        "Sinatra"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "JavaScript"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "PostgreSQL"
	      )
	    )
	  );
	};
	
	exports.default = Projects;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-195b85a694c525c47300.js